<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="$id('addSupplierModal')" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="$id('addSupplierModal')">{{header}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <select ref="supplier" class="form-control">
                                <option value="-1">{{$t('page.product.edit.modal.choose_supplier')}}</option>
                                <option v-for="(supplier, index) in suppliers" :value="index">{{supplier.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('no')">{{$t('page.product.edit.modal.close')}}</button>
                        <button type="button" class="btn btn-primary" @click="checkAndSubmit()">{{$t('page.product.edit.modal.save')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <QuestionModal :id="$id('errorModal')" :title="$t('page.product.edit.modal.error_title')" :message="errorMsg" @yes="toggleQuestion" @no="toggleQuestion" ></QuestionModal>
    </div>
</template>

<script>
    import QuestionModal from "../QuestionModal";

    export default {
        name: "AddSupplierModal",
        components: {
            QuestionModal,
        },
        data: function() {
            return {
                errorMsg: "",
                header: "",
                suppliers: [],
            }
        },
        props:{
            id: {
                type: String,
                required: true,
            },
            currentSuppliers: Object,
        },
        beforeMount: function(){
            this.header = this.$t('page.product.edit.modal.add_supplier_title');
        },
        methods:{
            loadSuppliers: function(suppliers){
                this.currentSuppliers = suppliers;

                axios.post('/manage/supplier/available', {
                    suppliers: vue.currentSuppliers
                }).then(function (response) {
                    let data = response["data"];

                    vue.suppliers = [];
                    data.forEach(function (supplier) {
                        vue.suppliers.push({
                            id: supplier.id,
                            name: supplier.name,
                        });
                    })
                })
            },
            checkAndSubmit: function (event) {
                let errorMsg = "";

                if( this.$refs["supplier"].value === "-1"){
                    errorMsg = this.$t('page.product.edit.modal.choose_supplier');
                }

                if( errorMsg === ""){
                    $('#' + this.id).modal("toggle");
                    this.$emit('save', this.suppliers[this.$refs["supplier"].value]);
                } else {
                    this.errorMsg = errorMsg;
                    this.toggleQuestion();
                }
            },
            toggleQuestion: function () {
                $('#' + this.$id('errorModal')).modal('toggle');
            }
        }
    }
</script>
